import WishlistShare from "../typescript/modules/wishlist-share";

new WishlistShare();
